import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const C = { primary:'#2E7D32', primaryDark:'#1B5E20', border:'#E0E0E0', light:'#F4F6F9', green100:'#E8F5E9', textDark:'#212121', textMid:'#616161', textLight:'#9E9E9E' };

const ROLE_COLORS = {
  super_admin: '#8B0000',
  admin: '#c0392b',
  responsable_facturation: '#8e44ad',
  agent_facturation: '#2980b9',
  prepose: '#1a5c2a',
  caissier: '#e67e22',
  comptable: '#16a085',
  verificateur: '#7f8c8d',
};

const FormUtilisateur = ({ utilisateur, abattoirs, roles, onSave, onCancel }) => {
  const estModif = !!utilisateur?.id;
  const [form, setForm] = useState({
    nom: utilisateur?.nom || '',
    prenom: utilisateur?.prenom || '',
    email: utilisateur?.email || '',
    role: utilisateur?.role || 'prepose',
    abattoir_id: utilisateur?.abattoir_id || '',
    telephone: utilisateur?.telephone || '',
    mot_de_passe_initial: '',
    employe_id: utilisateur?.employe_id || '',
  });
  const [employes, setEmployes] = useState([]);
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [chargement, setChargement] = useState(false);
  const [lienReset, setLienReset] = useState('');

  useEffect(() => {
    if (!estModif) {
      api.get('/rh/employes-cdi')
        .then(r => setEmployes(r.data.employes || []))
        .catch(() => setEmployes([]));
    }
  }, [estModif]);

  const champ = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const selectionnerEmploye = (e) => {
    const id = e.target.value;
    if (!id) {
      setForm({ ...form, employe_id: '', nom: '', prenom: '', email: '' });
      return;
    }
    const emp = employes.find(emp => emp.id === id);
    if (emp) {
      setForm({
        ...form,
        employe_id: emp.id,
        nom: emp.nom || '',
        prenom: emp.prenom || '',
        email: emp.email || '',
        role: emp.role_nom || form.role,
      });
    }
  };

  const soumettre = async (e) => {
    e.preventDefault();
    setChargement(true);
    try {
      const payload = { ...form };
      if (!payload.mot_de_passe_initial) delete payload.mot_de_passe_initial;
      if (!payload.employe_id) delete payload.employe_id;
      let r;
      if (estModif) {
        r = await api.put(`/users/${utilisateur.id}`, payload);
        setMessage({ type: 'succes', texte: 'Utilisateur modifie avec succes !' });
        onSave();
      } else {
        r = await api.post('/users', payload);
        if (r.data.lien_reset) setLienReset(r.data.lien_reset);
        setMessage({ type: 'succes', texte: 'Utilisateur cree avec succes !' });
        if (!r.data.lien_reset) onSave();
      }
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur serveur.' });
    } finally { setChargement(false); }
  };

  const SF = {
    overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    modal: { background: 'white', borderRadius: 12, padding: 28, width: 560, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.3)' },
    titre: { color: C.primaryDark, fontSize: 16, fontWeight: 700, marginBottom: 18, borderBottom: `2px solid ${C.primary}`, paddingBottom: 10 },
    grille: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
    label: { display: 'block', fontSize: 12, color: C.textMid, marginBottom: 4, fontWeight: 600 },
    input: { width: '100%', padding: '8px 10px', border: `1px solid ${C.border}`, borderRadius: 7, fontSize: 13, boxSizing: 'border-box', outline: 'none' },
    alerte: (t) => ({ padding: '10px 14px', borderRadius: 7, marginBottom: 14, background: t === 'succes' ? C.green100 : '#FFEBEE', color: t === 'succes' ? C.primaryDark : '#C62828', border: `1px solid ${t === 'succes' ? '#A5D6A7' : '#EF9A9A'}` }),
    btnPrimary: { background: C.primary, color: 'white', border: 'none', padding: '10px 22px', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', marginRight: 10 },
    btnSecondary: { background: '#9E9E9E', color: 'white', border: 'none', padding: '10px 18px', borderRadius: 8, fontSize: 14, cursor: 'pointer' },
    lienBox: { marginTop: 14, padding: 14, background: '#FFF8E1', borderRadius: 8, border: '1px solid #FFCC80' },
    employe: { marginBottom: 14, padding: 12, background: C.green100, borderRadius: 8, border: `1px solid #A5D6A7` },
  };
  const S = SF;

  const roleNeedAbattoir = !['admin', 'super_admin'].includes(form.role);

  return (
    <div style={S.overlay} onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div style={S.modal}>
        <div style={S.titre}>{estModif ? 'Modifier un utilisateur' : '+ Nouvel utilisateur'}</div>
        {message.texte && <div style={S.alerte(message.type)}>{message.texte}</div>}
        {lienReset ? (
          <div>
            <div style={S.lienBox}>
              <strong>Lien de reinitialisation pour {form.nom} :</strong>
              <div style={{ fontSize: 12, wordBreak: 'break-all', marginTop: 8, fontFamily: 'monospace', background: '#fffdf0', padding: 8, borderRadius: 4 }}>{lienReset}</div>
              <div style={{ marginTop: 8, display: 'flex', gap: 10 }}>
                <button style={{ ...S.btnPrimary, fontSize: 12 }} onClick={() => navigator.clipboard.writeText(lienReset)}>Copier</button>
                <button style={{ ...S.btnSecondary, fontSize: 12 }} onClick={onSave}>Fermer</button>
              </div>
            </div>
          </div>
        ) : (
          <form onSubmit={soumettre}>
            {!estModif && employes.length > 0 && (
              <div style={S.employe}>
                <label style={S.label}>Lier a un employe CDI (optionnel — remplit le formulaire automatiquement)</label>
                <select style={S.input} value={form.employe_id} onChange={selectionnerEmploye}>
                  <option value="">— Saisie manuelle —</option>
                  {employes.map(emp => (
                    <option key={emp.id} value={emp.id}>
                      {emp.nom} {emp.prenom} — {emp.poste || 'Poste non defini'}
                    </option>
                  ))}
                </select>
                {form.employe_id && (
                  <div style={{ fontSize: 12, color: '#2e7d32', marginTop: 6 }}>
                    Nom, prenom et email charges automatiquement depuis le RH
                  </div>
                )}
              </div>
            )}
            <div style={S.grille}>
              <div><label style={S.label}>Nom *</label><input style={S.input} name="nom" value={form.nom} onChange={champ} required /></div>
              <div><label style={S.label}>Prenom *</label><input style={S.input} name="prenom" value={form.prenom} onChange={champ} required /></div>
              <div style={{ gridColumn: '1 / -1' }}><label style={S.label}>Email *</label><input style={S.input} type="email" name="email" value={form.email} onChange={champ} required /></div>
              <div><label style={S.label}>Telephone</label><input style={S.input} name="telephone" value={form.telephone} onChange={champ} placeholder="+221 7X XXX XX XX" /></div>
              <div>
                <label style={S.label}>Role *</label>
                <select style={S.input} name="role" value={form.role} onChange={champ} required>
                  {roles.filter(r => r.nom !== 'super_admin').map(r => (
                    <option key={r.nom} value={r.nom}>{r.libelle}</option>
                  ))}
                </select>
              </div>
            </div>
            {roleNeedAbattoir && (
              <div style={{ marginBottom: 15 }}>
                <label style={S.label}>Abattoir *</label>
                <select style={S.input} name="abattoir_id" value={form.abattoir_id} onChange={champ} required={roleNeedAbattoir}>
                  <option value="">— Selectionner —</option>
                  {abattoirs.map(a => <option key={a.id} value={a.id}>{a.nom}</option>)}
                </select>
              </div>
            )}
            <div style={{ marginBottom: 15 }}>
              <label style={S.label}>Mot de passe</label>
              <input style={S.input} type="password" name="mot_de_passe_initial" value={form.mot_de_passe_initial} onChange={champ} placeholder={estModif ? 'Laisser vide pour ne pas changer' : 'Laisser vide pour generer un lien'} />
            </div>
            <div>
              <button type="submit" style={S.btnPrimary} disabled={chargement}>
                {chargement ? '...' : estModif ? 'Enregistrer' : 'Creer'}
              </button>
              <button type="button" style={S.btnSecondary} onClick={onCancel}>Annuler</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default function GestionUtilisateursPage() {
  const navigate = useNavigate();
  const { utilisateur: moi } = useAuth();
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [abattoirs, setAbattoirs] = useState([]);
  const [roles, setRoles] = useState([]);
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [afficherForm, setAfficherForm] = useState(false);
  const [utilisateurEdit, setUtilisateurEdit] = useState(null);
  const [filtreRole, setFiltreRole] = useState('');
  const [filtreActif, setFiltreActif] = useState('');
  const [resetInfo, setResetInfo] = useState(null);

  const charger = async () => {
    try {
      const [r1, r2, r3] = await Promise.all([
        api.get('/users'),
        api.get('/abattoirs'),
        api.get('/roles'),
      ]);
      setUtilisateurs(r1.data);
      setAbattoirs(r2.data);
      setRoles(Array.isArray(r3.data) ? r3.data : []);
    } catch (e) { setMessage({ type: 'erreur', texte: 'Erreur chargement.' }); }
  };

  useEffect(() => { charger(); }, []);

  const toggleActif = async (id, nom) => {
    if (!window.confirm(`Changer le statut du compte de ${nom} ?`)) return;
    try {
      const r = await api.put(`/users/${id}/toggle-actif`);
      setMessage({ type: 'succes', texte: `Compte ${r.data.actif ? 'active' : 'desactive'}.` });
      charger();
    } catch (e) { setMessage({ type: 'erreur', texte: 'Erreur.' }); }
  };

  const resetMdp = async (id, nom) => {
    if (!window.confirm(`Reinitialiser le mot de passe de ${nom} ?`)) return;
    try {
      const r = await api.put(`/users/${id}/reinitialiser-mdp`, {});
      if (r.data.lien_reset) {
        setResetInfo({ nom, lien: r.data.lien_reset });
      } else {
        setMessage({ type: 'succes', texte: "Mot de passe reinitialise. L'utilisateur devra le changer a la prochaine connexion." });
      }
    } catch (e) { setMessage({ type: 'erreur', texte: 'Erreur.' }); }
  };

  const roleInfo = (roleNom) => {
    const r = roles.find(r => r.nom === roleNom);
    if (r) return { label: r.libelle, color: ROLE_COLORS[r.nom] || '#888' };
    return { label: roleNom || '—', color: '#888' };
  };

  const filtres = utilisateurs.filter(u => {
    if (filtreRole && u.role !== filtreRole) return false;
    if (filtreActif === '1' && !u.actif) return false;
    if (filtreActif === '0' && u.actif) return false;
    return true;
  });

  const SM = {
    page: { minHeight: '100vh', background: C.light },
    topbar: { height: 52, background: '#fff', borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', position: 'sticky', top: 0, zIndex: 100 },
    breadcrumb: { fontSize: 13, color: C.textLight, display: 'flex', alignItems: 'center', gap: 6 },
    breadcrumbActive: { color: C.textDark, fontWeight: 600 },
    container: { maxWidth: 1300, margin: '20px auto', padding: '0 20px', paddingBottom: 40 },
    carte: { background: 'white', borderRadius: 12, border: `0.5px solid ${C.border}`, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', overflow: 'hidden' },
    carteFiltre: { background: 'white', borderRadius: 10, padding: '12px 16px', marginBottom: 14, border: `0.5px solid ${C.border}`, display: 'flex', gap: 14, alignItems: 'flex-end', flexWrap: 'wrap' },
    label: { display: 'block', fontSize: 12, color: C.textMid, marginBottom: 4, fontWeight: 600 },
    input: { padding: '7px 10px', border: `1px solid ${C.border}`, borderRadius: 7, fontSize: 13, outline: 'none' },
    alerte: (t) => ({ padding: '10px 14px', borderRadius: 7, marginBottom: 12, background: t === 'succes' ? C.green100 : '#FFEBEE', color: t === 'succes' ? C.primaryDark : '#C62828', border: `1px solid ${t === 'succes' ? '#A5D6A7' : '#EF9A9A'}` }),
    table: { width: '100%', borderCollapse: 'collapse', fontSize: 12 },
    th: { background: '#F8F9FA', color: C.textMid, padding: '8px 12px', textAlign: 'left', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', borderBottom: `1px solid ${C.border}`, whiteSpace: 'nowrap' },
    td: { padding: '9px 12px', borderBottom: '1px solid #F0F2F4', verticalAlign: 'middle', fontSize: 12, color: C.textDark },
    btnVert: { background: C.primary, color: 'white', border: 'none', padding: '5px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 700, marginRight: 4 },
    btnOrange: { background: '#E65100', color: 'white', border: 'none', padding: '5px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 700, marginRight: 4 },
    btnRouge: { background: '#C62828', color: 'white', border: 'none', padding: '5px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 700, marginRight: 4 },
    btnGris: { background: '#9E9E9E', color: 'white', border: 'none', padding: '5px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontWeight: 700 },
    badgeRole: (role) => ({ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700, background: (ROLE_COLORS[role] || '#888') + '22', color: ROLE_COLORS[role] || '#888' }),
    badgeActif: (actif) => ({ display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700, background: actif ? C.green100 : '#FFEBEE', color: actif ? C.primaryDark : '#C62828' }),
  };

  return (
    <div style={SM.page}>
      <div style={SM.topbar}>
        <div style={SM.breadcrumb}>
          <span>Administration</span>
          <span style={{ color: C.border }}>›</span>
          <span style={SM.breadcrumbActive}>Gestion des utilisateurs</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={{ background: '#E3F2FD', border: '1px solid #90CAF9', color: '#1565C0', padding: '6px 14px', borderRadius: 7, cursor: 'pointer', fontSize: 12, fontWeight: 600 }} onClick={() => navigate('/users/audit')}>📋 Journal d'audit</button>
        </div>
      </div>

      <div style={SM.container}>
        {message.texte && <div style={SM.alerte(message.type)}>{message.texte}</div>}

        {resetInfo && (
          <div style={{ padding: '10px 15px', borderRadius: 6, marginBottom: 15, background: '#fff3cd', color: '#856404', border: '1px solid #ffc107' }}>
            <strong>Lien de reinitialisation pour {resetInfo.nom} :</strong>
            <div style={{ fontSize: 12, wordBreak: 'break-all', marginTop: 8, fontFamily: 'monospace', background: '#fffdf0', padding: 8, borderRadius: 4 }}>{resetInfo.lien}</div>
            <div style={{ marginTop: 8, display: 'flex', gap: 10 }}>
              <button style={{ ...SM.btnVert, fontSize: 12 }} onClick={() => navigator.clipboard.writeText(resetInfo.lien)}>Copier</button>
              <button style={{ ...SM.btnGris, fontSize: 12 }} onClick={() => setResetInfo(null)}>Fermer</button>
            </div>
          </div>
        )}

        <div style={SM.carteFiltre}>
          <div>
            <label style={SM.label}>Role</label>
            <select style={SM.input} value={filtreRole} onChange={e => setFiltreRole(e.target.value)}>
              <option value="">Tous les roles</option>
              {roles.filter(r => r.nom !== 'super_admin').map(r => (
                <option key={r.nom} value={r.nom}>{r.libelle}</option>
              ))}
            </select>
          </div>
          <div>
            <label style={SM.label}>Statut</label>
            <select style={SM.input} value={filtreActif} onChange={e => setFiltreActif(e.target.value)}>
              <option value="">Tous</option>
              <option value="1">Actifs</option>
              <option value="0">Desactives</option>
            </select>
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <button style={{ background: C.primary, color: 'white', border: 'none', padding: '8px 18px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 700 }} onClick={() => { setUtilisateurEdit(null); setAfficherForm(true); }}>
              + Nouvel utilisateur
            </button>
          </div>
          <div style={{ color: C.textLight, fontSize: 12, alignSelf: 'center' }}>
            {filtres.length} utilisateur(s)
          </div>
        </div>

        <div style={SM.carte}>
          <table style={SM.table}>
            <thead>
              <tr>
                <th style={SM.th}>Nom Prenom</th>
                <th style={SM.th}>Email</th>
                <th style={SM.th}>Telephone</th>
                <th style={SM.th}>Role</th>
                <th style={SM.th}>Abattoir</th>
                <th style={SM.th}>Statut</th>
                <th style={SM.th}>Derniere connexion</th>
                <th style={SM.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtres.map(u => (
                <tr key={u.id} style={{ background: u.actif ? 'white' : '#FAFAFA', opacity: u.actif ? 1 : 0.65 }}>
                  <td style={SM.td}>
                    <strong>{u.nom} {u.prenom}</strong>
                    {u.premier_login && <span style={{ marginLeft: 6, fontSize: 10, background: '#FFF8E1', color: '#E65100', padding: '2px 6px', borderRadius: 10 }}>1er login</span>}
                    {u.id === moi?.id && <span style={{ marginLeft: 6, fontSize: 10, background: C.green100, color: C.primaryDark, padding: '2px 6px', borderRadius: 10 }}>Moi</span>}
                  </td>
                  <td style={SM.td}>{u.email}</td>
                  <td style={SM.td}>{u.telephone || '–'}</td>
                  <td style={SM.td}><span style={SM.badgeRole(u.role)}>{roleInfo(u.role).label}</span></td>
                  <td style={SM.td}>{u.abattoir_nom || <span style={{ color: C.textLight, fontStyle: 'italic' }}>Tous</span>}</td>
                  <td style={SM.td}><span style={SM.badgeActif(u.actif)}>{u.actif ? 'Actif' : 'Desactive'}</span></td>
                  <td style={SM.td} title={u.derniere_connexion}>
                    {u.derniere_connexion ? new Date(u.derniere_connexion).toLocaleString('fr-FR') : <span style={{ color: C.textLight }}>Jamais connecte</span>}
                  </td>
                  <td style={SM.td}>
                    <button style={SM.btnOrange} onClick={() => { setUtilisateurEdit(u); setAfficherForm(true); }}>Modifier</button>
                    <button style={SM.btnRouge} onClick={() => resetMdp(u.id, `${u.nom} ${u.prenom}`)}>MDP</button>
                    {u.id !== moi?.id && (
                      <button style={u.actif ? SM.btnGris : SM.btnVert} onClick={() => toggleActif(u.id, `${u.nom} ${u.prenom}`)}>
                        {u.actif ? 'Bloquer' : 'Activer'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {afficherForm && (
          <FormUtilisateur
            utilisateur={utilisateurEdit}
            abattoirs={abattoirs}
            roles={roles}
            onSave={() => { setAfficherForm(false); setUtilisateurEdit(null); charger(); }}
            onCancel={() => { setAfficherForm(false); setUtilisateurEdit(null); }}
          />
        )}
      </div>
    </div>
  );
}
